import request from 'utils/request';
import config from 'config/Config';
import Stores from 'config/Stores';
import { hex_md5, Encrypts } from 'utils/md5';
import { decryptParams } from 'utils/constants';

export default class {
  // 获取名片详情
  static getCardInfo(params) {
    return request({
      host: config.HOST_PROMOTE,
      url: 'userCard/detail/get',
      params,
      ignoreErr: true
    });
  }
  /**
   * 获取名片模板数据
   */
  static getCardModuleTemplate(belongSystem) {
    return request({
      host: config.HOST_MALL,
      url: `content/recommandUi/sort?sysTemCode=${belongSystem}`
    });
  }

  // 编辑名片 - 保存信息
  static saveMsg(params) {
    return request({
      host: config.HOST_PROMOTE,
      url: 'userCard/update',
      method: 'post_json',
      data: params
    });
  }

  // 最新资讯
  static getLateNews() {
    return request({
      url: 'content/article/getLateThree',
      host: config.HOST_MALL
    });
  }

  //推荐产品
  static getImgText() {
    return request({
      url: 'content/recommandUi/itemGrid/1/2',
      host: config.HOST_MALL
    });
  }

  // 促销用户选择的促销活动
  static getSelectActivityList(params) {
    return request({
      url: 'promotion/query/activity',
      host: config.HOST_MALL,
      params
    });
  }

  // 查询用户相关的所有活动列表
  static getUserActivityList() {
    return request({
      url: 'promotion/query/list',
      host: config.HOST_MALL
    });
  }

  // 关联用户和活动
  static getUserConnectActivity(params) {
    return request({
      url: 'promotion/add/act/user',
      host: config.HOST_MALL,
      method: 'POST_JSON',
      params
    });
  }
  // 用户新增推荐商品
  static addProductRecommend(params) {
    return request({
      url: 'content/card/item/add/item/user',
      host: config.HOST_MALL,
      method: 'POST_JSON',
      params: params
    });
  }
  // 根据用户获取勾选的推荐商品
  static getProductRecommendList(params) {
    return request({
      url: 'content/card/item/query/items',
      host: config.HOST_MALL,
      method: 'POST_JSON',
      params
    });
  }
  // 获取用户选择的推荐的商品ID
  static getProductRecommendIdList(params) {
    return request({
      url: 'content/card/item/query/ids',
      host: config.HOST_MALL,
      method: 'POST_JSON',
      params
    });
  }
  // 用户删除勾选的推荐商品
  static productDelete(params) {
    return request({
      url: 'content/card/item/delete/item',
      host: config.HOST_MALL,
      method: 'POST_JSON',
      params: params
    });
  }

  // 获取视频列表
  static getVideoList() {
    return request({
      url: 'content/card/video/list',
      host: config.HOST_MALL
    });
  }

  // 获取用户选择的产品视频
  static getSelectVideoList(params) {
    return request({
      url: 'content/card/video/query/video',
      host: config.HOST_MALL,
      params
    });
  }

  // 新增用户关联的视频
  static userConnectVideo(params) {
    return request({
      url: 'content/card/video/add/video/user',
      host: config.HOST_MALL,
      method: 'POST_JSON',
      params
    });
  }

  // 新增用户视频
  static addVideo(params) {
    return request({
      url: 'content/card/video/add/user',
      host: config.HOST_MALL,
      method: 'POST_JSON',
      params
    });
  }

  // 删除用户视频
  static delVideo(params) {
    return request({
      url: 'content/card/video/delete',
      host: config.HOST_MALL,
      method: 'POST_JSON',
      params
    });
  }
  // 数据总览信息上报
  static addComeIn(params) {
    return request({
      url: 'content/card/statistics/add/view',
      host: config.HOST_MALL,
      params
    });
  }

  // 数据总览信息获取
  static getComeIn(params) {
    return request({
      url: 'content/card/statistics/query/report',
      host: config.HOST_MALL,
      params
    });
  }

  // 查询公司介绍
  static getCompanyIntroduce() {
    return request({
      url: `content/companyProfile/query/enable`,
      host: config.HOST_MALL
    });
  }

  // 保存访客者信息
  static saveVisitUserInfo(params) {
    return request({
      url: `content/card/statistics/add/view`,
      host: config.HOST_MALL,
      method: 'POST_JSON',
      data: params
    });
  }

  static getQrcodeShow(id) {
    return request({
      url: `userCard/detail/get?id=${id}`,
      host: config.HOST_PROMOTE
    });
  }

  /**
   * 赠送生日祝福
   * @param {} params
   * @returns
   */
  static sendBirthDayWish(params) {
    return request({
      url: `agenda/addBirthdayWishes`,
      host: config.HOST_PROMOTE,
      method: 'POST_JSON',
      data: params
    });
  }

  /**
   * 校验是否已经送过生日祝福
   */
  static checkBirthdayWishes(params) {
    return request({
      url: `agenda/checkBirthdayWishes`,
      host: config.HOST_PROMOTE,
      method: 'POST_JSON',
      data: params
    });
  }

  /**
   * 获取用权限点
   */
  static getGongSiEnterList() {
    return request({
      url: `user/info/getGongSiEnterList`,
      host: config.HOST_MALL,
      method: 'GET'
    });
  }

  /**
   * 获取用权限点
   */
  static getEnterList() {
    return request({
      url: `user/info/getEnterList`,
      host: config.HOST_MALL
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Promote/BusinessCard/BusinessCardServ.js